<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />

          {{ /* table controllerscontrollers */ }}
          <div>
            <div class="form-group form-inline pull-left">
              <b-button href variant="primary" size="sm" @click="sync()">
                <span class="glyphicon glyphicon-refresh"></span>
              </b-button>&nbsp;
              <import-button ref="importButton" :order-status-id="orderType.id" v-if="orderType.name === 'import'"
                @imported="onImported"></import-button>&nbsp;
              <b-button href variant="primary" size="sm" :disabled="serverParams.ids.length < 1"
                @click="printOrders()">Batch Print to Printer</b-button>&nbsp;
              <b-button href variant="danger" size="sm" :disabled="serverParams.ids.length < 1" @click="deleteOrders"
                v-if="orderType.name === 'import'">Delete</b-button>&nbsp;
            </div>

            <div class="form-group form-inline pull-right">
              <b-input v-model="searchTerm" placeholder="Search" size="sm" />
              &nbsp;
              <b-dropdown id="dropdown-1" text="Edit Columns" size="sm">
                <b-dropdown-form style="padding-left: 0.5rem">
                  <b-form-checkbox-group v-model="selectedColumns">
                    <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                      {{ col.label }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <b-dropdown-item-button @click="onVGTColumnSelect">
                    <b-button size="sm" block>Apply</b-button>
                  </b-dropdown-item-button>
                </b-dropdown-form>
              </b-dropdown>
              &nbsp;
              <b-button size="sm" @click="exportOrders('csv')">
                Export Data
                <span class="glyphicon glyphicon-download-alt"></span>
              </b-button>
            </div>
          </div>
          {{ /* table controllerscontrollers */ }}

          <div class="clearfix"></div>
          {{ /* VGT */ }}
          <vue-good-table ref="vgt" mode="remote" :columns="columns" :rows="rows"
            styleClass="vgt-table striped bordered condensed" max-height="70vh"
            :select-options="{ enabled: true, selectOnCheckboxOnly: true }"
            :search-options="{ enabled: true, externalQuery: searchTerm }"
            :pagination-options="{ enabled: true, mode: 'records', perPageDropdown: [25, 50, 100, 200], dropdownAllowAll: false }"
            :totalRows="totalRecords" :line-numbers="true" @on-search="onVGTSearch"
            @on-selected-rows-change="onVGTSelected" @on-page-change="onVGTPageChange" @on-sort-change="onVGTSortChange"
            @on-column-filter="onVGTColumnFilter" @on-per-page-change="onVGTPerPageChange">
            <div slot="emptystate"> N/A </div>
            <template slot="table-row" slot-scope="props">
              <!-- ACTION -->
              <span v-if="props.column.field === 'id'">
                <button v-if="orderStatusId === 2 || orderStatusId === 3" class="btn btn-primary btn-xs"
                  :disabled="!props.row.rate || !props.row.shipping_service_id"
                  :title="!props.row.rate || !props.row.shipping_service_id ? 'Please fill out all required information before printing.' : ''"
                  @click="printOrder(props.row.id)">Ship</button>
                <button v-if="orderStatusId !== 3" class="btn btn-primary btn-xs view"
                  @click="showOrder(props.row.id)">View</button>
                <button v-if="orderStatusId === 1" class="btn btn-primary btn-xs"
                  @click="(value) => { onEditOrder.call(this, props.row, 'order_status_id', 2) }">Move</button>
              </span>
              <!-- SHIPPING SERVICE -->
              <span v-else-if="props.column.field === 'shipping_service'">
                <b-form-select v-if="orderStatusId !== 3" :value="props.row.shipping_service_id"
                  :options="serviceOptions(props.row.shipping_address_country)" size="sm"
                  @change="(value) => { onEditOrder.call(this, props.row, 'shipping_service_id', value) }" />
                <div v-else>{{ props.row.shipping_service }}</div>
              </span>
              <!-- PACKAGE_TYPE -->
              <span v-else-if="props.column.field === 'package_type'">
                <b-form-select v-if="orderStatusId !== 3" :value="props.row.package_type_code"
                  :options="packageOptions(props.row.shipping_service_code, props.row.shipping_address_country)"
                  @change="(value) => { onEditOrder.call(this, props.row, 'package_type', value) }" size="sm" />
                <div v-else>{{ props.row.package_type }}</div>
              </span>
              <!-- TOTAL WEIGHT -->
              <span v-else-if="props.column.field === 'total_weight'">
                <div role="group" class="input-group weight-inputs" v-if="orderStatusId !== 3">
                  <b-form-input :id="`weight-lb-${props.row.id}`" :ref="`weight_lb_${props.row.id}`"
                    :value="props.row.total_weight ? getWeight(props.row.total_weight).lb : 0.0" type="number"
                    @change="(value) => { onEditOrder.call(this, props.row, 'weight_lb', value) }"
                    size="sm"></b-form-input>
                  <div class="input-group-append">
                    <div class="input-group-text btn-sm">lb</div>
                  </div>
                  <b-form-input :id="`weight-oz-${props.row.id}`" :ref="`weight_oz_${props.row.id}`"
                    :value="props.row.total_weight ? getWeight(props.row.total_weight).oz : 0.0" type="number"
                    @change="(value) => { onEditOrder.call(this, props.row, 'weight_oz', value) }"
                    size="sm"></b-form-input>
                  <div class="input-group-append">
                    <div class="input-group-text btn-sm">oz</div>
                  </div>
                </div>
                <div v-else>
                  {{ getWeight(props.row.total_weight).lb }}lb
                  {{ getWeight(props.row.total_weight).oz }}oz
                </div>
              </span>
              <span v-else-if="props.column.field === 'marketplace'">
                <img v-if="props.row.marketplace" v-bind:src="props.row.marketplace.img" class="img-responsive" />
                <span v-else>.</span>
              </span>
              <span v-else-if="props.column.field === 'address'">
                {{ props.row.address.address1 }} <br />
                {{ props.row.address.address2 }} <br />
                {{ props.row.address.address3 }}
              </span>
              <span v-else-if="props.column.field === 'name'">
                {{ props.row.name.name }} <br />
                {{ props.row.name.company }}
              </span>
              <span v-else-if="props.column.field === 'created_at'">
                {{ props.row.created_at | readableDate }}
              </span>
              <span
                v-else-if="['declared_value', 'rate', 'total_price', 'insurance_price', 'tracking_price'].includes(props.column.field)">
                {{ format.price(props.row[props.column.field]) }}
              </span>
              <span v-else-if="props.column.field === 'total_weight'">
                {{ getWeight(props.row.total_weight).lb }}lb
                {{ getWeight(props.row.total_weight).oz }}oz
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

          </vue-good-table>
          {{ /* VGT */ }}

        </b-card>
      </div>
    </div>

    <div>
      <ShowOrder ref="viewOrderModal" :key="shown.id" :orderobj="shown" v-if="shown !== null" @hide="onShowOrderHide">
      </ShowOrder>
    </div>
  </div>
</template>
<style lang="scss">
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  &+.calendar-root {
    .input-date {
      display: none;
    }

    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}

.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }

  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import ShowOrder from "./ShowShippedInModal";
import ImportButton from "../../components/ImportButton";
import moment from "moment";
import Cookies from 'js-cookie';
import hash from 'object-hash';
import { mapGetters, mapActions } from "vuex";
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ShowOrder,
    ImportButton
  },
  props: {
    orderStatusId: Number,
    orderStatusName: String
  },
  data() {
    return {
      isLoading: false,
      // value could be 3 for shipped,4 for voided,5 for returns
      orderType: {
        id: 2,
        name: 'import',
      },

      // for modal
      shown: null,
      shownObjs: {},

      selectedColumns: [
        "marketplace", "order_number", "created_at", "name",
        "shipping_service", "package_type", "total_weight", "total_price",
      ],
      selected: [],
      searchTerm: '',
      serverParams: {
        columns: null,
        marketType: null,
        dateRange: null,
        searchTerm: '',
        ids: [],
        columnFilters: null,
        sort: null,
        page: null,
        perPage: null
      },
      marketplaceOptions: [],
      totalRecords: 0,
      rows: [],
      columns: [
        {
          field: 'id', label: "Actions",
          thClass: "vgt-headers",
          sortable: false,
        },
        {
          field: 'marketplace', label: "Marketplace",
          thClass: "vgt-headers",
        },
        {
          field: 'origin_address', label: "Origin Address",
          thClass: "vgt-headers", hidden: true,
        },
        {
          field: 'origin_postal', label: "Origin Postal",
          thClass: "vgt-headers", hidden: true,
        }, {
          field: 'order_number', label: "Order Number",
          thClass: "vgt-headers",
        },
        {
          field: 'created_at', label: "Shipment Date", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass: "vgt-headers wide",
        },
        {
          field: 'name', label: "Recipient",
          thClass: "vgt-headers",
        },
        {
          field: 'address', label: "Address",
          thClass: "vgt-headers widest",
          hidden: true,
        },
        {
          field: 'shipping_service', label: "Service Class",
          sortable: false,
          thClass: "vgt-headers wider",
        },
        {
          field: 'rate', label: "Shipping Rate",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'package_type', label: "Package Type",
          sortable: false,
          thClass: "vgt-headers wider",
        },
        {
          field: 'total_weight', label: "Weight",
          sortable: false,
          thClass: "vgt-headers widest",
        },
        {
          field: 'dimension', label: "Dimensions",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'tracking_price', label: "Additional Tracking",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        // {
        //   field: 'insurance_price', label: "Insurance",
        //   sortable: false, hidden: true,
        //   thClass:"vgt-headers",
        // },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'total_price', label: "Total Cost",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: 'label_sticky', label: "Custom Field 1",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'label_sticky_2', label: "Custom Field 2",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'email', label: "Email",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'phone', label: "Phone",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }
      ],
    }
  }, // end of data
  computed: {
    ...mapGetters({ serviceOptions: "serviceOptions" }),
    shipping_service_options() {
      return this.$store.state.shipping_services
        .map(shippingService => {
          return {
            value: shippingService.id,
            text: shippingService.name
          };
        })
        .sort((a, b) => {
          return (
            sorting.services[a.value.code] - sorting.services[b.value.code]
          );
        });
    },
    columnSelection() {
      return this.columns.map(v => {
        const { field, label } = v;
        if (v.field !== 'id') return { field, label };
      }).filter(v => !!v);
    },
  },
  async mounted() {
    this.orderType = {
      id: this.orderStatusId,
      name: this.orderStatusName,
    };
    console.log('oder type', this.orderType);
    // clear session every page visit then fetch new data
    await this.clearSessionAndFetch(this.orderType.name);
  },
  methods: {
    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTSelected(params) {
      console.log('on select', params);
      if (params.selectedRows.length > 0) {
        const ids = params.selectedRows.map(v => v.id);
        this.updateVGTParams({ ids });
      } else {
        this.updateVGTParams({ ids: [] });
      }
    },
    onVGTSearch(params) {
      console.log('on search', params);
      this.updateVGTParams({ searchTerm: params.searchTerm });
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTPageChange(params) {
      console.log('on pagination', params);
      this.updateVGTParams({ page: params.currentPage });
      this.fetchOrders();
    },
    onVGTPerPageChange(params) {
      console.log('on per page change', params);
      this.updateVGTParams({ perPage: params.currentPerPage });
      // needs to clear everything since since the number of pages is already invalid
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTSortChange(params) {
      console.log('on sort change', params);
      if (!params.length) return
      const { field, type } = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTColumnFilter(params) {
      console.log('on columnfilter', params);
      this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTColumnSelect() {
      console.log('on selectColumns', this.selectedColumns);
      this.columns = this.columns.map(column => {
        if (column.field !== 'id') {
          column.hidden = this.selectedColumns.includes(column.field) ? false : true;
        }
        return column;
      })
      this.updateVGTParams({ columns: this.selectedColumns });

    },
    onVGTDateRangeSelected(params) {
      const { end, start } = params;
      console.log('on daterange start', start);
      console.log('on daterange end', end);
      this.updateVGTParams({ dateRange: [start, end] });
      // this.updateVGTParams(params);
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTMarketplaceChange() {
      console.log('on marketplace change', this.serverParams.marketType);
      this.clearSessionAndFetch(this.orderType.name);
    }, // VGT EVENTS

    async fetchOrders(page_url = `/orders-vgt`) {
      try {
        this.isLoading = true;
        const isExisting = await this.getFromSession(this.serverParams.page, this.orderType.name);
        // if in session no need to call server
        if (isExisting) {
          console.log('existing', isExisting);
          this.rows = isExisting;
          return;
        }
        const response = await axios.get(page_url, {
          params: Object.assign({}, { status: this.orderType.id, with_type: this.orderType.name }, this.serverParams)
        });
        const { data: { data, total } } = response;
        console.log(data, total);
        this.totalRecords = total;
        this.rows = data.map(order => {
          return this.mapToRows(order, this.orderType.id);
        });
        this.saveToSession(this.serverParams.page, this.rows, this.orderType.name);
        // console.log('rows', this.rows);
        // console.log("ORDERS: ", this.orders);
      } catch (e) {
        console.error('error fetching orders', e);
      } finally {
        this.isLoading = false;
      }
    }, // get data from server
    mapToRows: function (order) {
      const pkgtypes = {
        PKG: 'Package',
        SOFTPACK: 'Cubic Soft Pack',
        FRE: 'Flat Rate Envelope',
        SFRB: 'Small Flat Rate Box',
        FRB: 'Medium Flat Rate Box',
        LFRB: 'Large Flat Rate Box',
        PFRENV: 'Flat Rate Padded Envelope',
        LGLFRENV: 'Flat Rate Legal Envelope',
        MLFRB: 'Military Large Flat Rate Box',
      };
      let status = 'label_status.exception';
      return {
        id: order.id,
        marketplace: order.marketplace_id ? {
          img: `/images/integrations/${order.marketplace_code}/table-icon.png`,
          id: order.marketplace_id,
          name: order.marketplace_name
        } : null,
        origin_address: order.origin_id ? `${order.origin_company} ${order.origin_first_name} ${order.origin_last_name}` : '',
        origin_postal: order.origin_id ? order.origin_postal_origin : '',
        order_number: order.order_number,
        created_at: order.created_at,
        // shipped_at: order.shipped_at,
        name: {
          name: `${order.shipping_address_first_name} ${order.shipping_address_last_name}`,
          company: order.shipping_address_company || ''
        },
        address: {
          address1: `${order.shipping_address_address} ${order.shipping_address_address2}`,
          address2: `${order.shipping_address_city} ${order.shipping_address_province}`,
          address3: `${order.shipping_address_country} ${order.shipping_address_postal_code}`
        },
        shipping_address_country: order.shipping_address_country, // needed for dropdown
        shipping_service_code: order.shipping_service_code, // needed for dropdown
        shipping_service_id: order.shipping_service_id, // needed for dropdown
        shipping_service: order.shipping_service_name,
        rate: order.rate,
        package_type: order.package_type ? pkgtypes[order.package_type] : '',
        package_type_code: order.package_type,
        total_weight: order.total_weight,
        dimension: `${order.package_length} x ${order.package_width} x ${order.package_height}`,
        tracking_price: order.tracking_price,
        insurance_price: order.insurance_price,
        declared_value: order.declared_value,
        total_price: order.rate + order.tracking_price + order.insurance_price,
        label_sticky: order.label_sticky,
        label_sticky_2: order.label_sticky_2,
        email: order.shipping_address_email,
        phone: order.shipping_address_phone,
      }
    }, // DATA

    // EXPORT
    async exportOrders(exportType = 'csv', returns = false,) {
      try {
        const msg = 'The current date range and active columns will be exported into a CSV file';
        if (!Cookies.get(hash(msg))) {
          let dialog = await this.$dialog.confirm(msg, { view: 'pausable' });
          dialog.close();
        }

        const url = `/orders/export-vgt`;
        const headings = this.columns.map(column => {
          if (this.selectedColumns.includes(column.field) && column.field !== 'id') {
            return { [column.field]: column.label };
          }
        }).filter(v => !!v);
        const data = { headings, type: exportType, dateNow: moment().format('MMDDYYYY') }

        const response = await axios.post(url, data, {
          params: Object.assign({}, { status: this.orderType.id }, this.serverParams)
        });
        // console.log('export response', response);
        window.open(response.data.url);
      } catch (e) {
        console.log(e);
      }
    }, // EXPORT

    // MARKETPLACE OPTIONS
    async getMarketPlaces() {
      const mOptions = sessionStorage.getItem('marketplace_options');
      if (mOptions) {
        this.marketplaceOptions = JSON.parse(mOptions);
      } else {
        console.log('getting marketplace options');
        const { data } = await axios.get('/marketplaces-vgt');
        console.log('marketplaces', data);
        const marketplaces = data.map(m => {
          return {
            value: m.id,
            text: m.name
          };
        });

        const options = [{ value: "all", text: "All" }, ...marketplaces];
        console.log('options', options);
        sessionStorage.setItem('marketplace_options', JSON.stringify(options));
        this.marketplaceOptions = options;
      }
    }, // MARKETPLACE OPTIONS

    // SESSION
    async clearSessionAndFetch(sessName = 'shipped') {
      try {
        console.log('clearing session');
        sessionStorage.removeItem(sessName);
        this.updateVGTParams({
          page: 1
        })
        await this.fetchOrders();
      } catch (e) {
        console.error(e);
      }
    },
    async saveToSession(pageNumber, orders, sesName = 'shipped') {
      try {
        console.log('setting session');
        let oldData = sessionStorage.getItem(sesName);
        oldData = oldData ? JSON.parse(oldData) : {};
        const newData = Object.assign({}, oldData, { [pageNumber]: orders });
        sessionStorage.setItem(sesName, JSON.stringify(newData));
        return true;
      } catch (e) {
        console.error(e);
      }

    },
    async getFromSession(pageNumber, sesName = 'shipped') {
      try {
        console.log('getting session');
        const shippedData = sessionStorage.getItem(sesName);
        // no data in session yet
        if (shippedData === null) return null;

        const newData = JSON.parse(shippedData);
        return newData[pageNumber] || null;
      } catch (e) {
        console.error(e);
      }
    }, // SESSION

    packageOptions(serviceId, ctry) {
      try {
        var scrules = this.$store.getters.getServiceCarrierRules(ctry);
        let rules = this.$store.getters.getServicePackageRules(serviceId, ctry, true); // filter inactive mail classes
        console.log("packageOptions(" + serviceId + "," + ctry + ")  .... " + rules.length);

        const flatRates = {
          EM: {
            FRE: "$22.68",
            LGLFRENV: "$22.80",
            PFRENV: "$23.18"
          },
          PM: {
            FRE: "$6.95",
            SFRB: "$7.50",
            LFRB: "$17.60",
            LGLFRENV: "$7.25",
            FRB: "$12.80",
            MLFRB: "$16.10",
            PFRENV: "$7.55"
          }
        };

        // console.log(scrules, rules);

        let options = serviceId
          ? rules.map(rule => {
            let name = rule.brandedName;

            if (
              serviceId in flatRates &&
              rule.parcelType in flatRates[serviceId]
            ) {
              name += " - " + flatRates[serviceId][rule.parcelType];
            }

            return {
              value: rule.parcelType,
              text: name
            };
          })
          : [];

        return _.orderBy(options, "text");
      } catch (e) {
        console.error(e);
      }
    },
    async onEditOrder(order, attribute, value) {
      try {
        const orderIndex = this.rows.findIndex(o => o.id === order.id);

        if (orderIndex < 0) {
          return;
        }

        if (attribute === "weight_lb" || attribute === "weight_oz") {
          if (attribute === "weight_lb") {
            value =
              parseFloat(value) * 16 +
              parseFloat(this.$refs["weight_oz_" + order.id].value);
          } else if (attribute === "weight_oz") {
            value =
              parseFloat(value) + this.$refs["weight_lb_" + order.id].value * 16;
          }

          attribute = "total_weight";
        }

        this.rows[orderIndex][attribute] = value;
        let data = {};
        data[attribute] = value;
        await this.onEditOrderSubmit(order.id, data);
      } catch (e) {
        console.error(e);
      }
    },
    async onEditOrderSubmit(orderId, data) {
      try {
        const order = this.getOrderById(orderId);
        console.log('order', order);
        if (order) {
          this.isLoading = true;
          const response = await axios.patch("/orders/" + orderId, data);
          console.log('edieordersubmit', response);
          this.$emit("alert", {
            message: response.data.message,
            type: "success"
          });
        }
      } catch (e) {
        this.$emit("alert", {
          message: e.message,
          type: "danger"
        });
        console.error(e);
      } finally {
        this.fetchOrders();
        this.isLoading = false;
      }
    },
    getOrderById(orderId) {
      const order = this.rows.find(o => o.id === orderId);
      return order || null;
    },
    onEditOrderReset(e) { },
    showImportModal() {
      this.$refs.importOrdersModal.show();
    },
    async printOrder(orderId) {
      this.isLoading = true;
      try {
        const response = await axios.post("printlabel/" + orderId);
        // this.shipper_addresses = response.data;
        //this.order.label_print = response.data.documents[0].contents;

        // Add to printer
        const decoded = response.data;
        //const decoded = atob(response.data.label)
        this.addPrintJob(decoded);
        //window.open(response.data.label);
      } catch (e) {
        console.error(e);
        let message = e.response.data.message;
        if (e.response.data.errors) {
          message += ": ";
          message += Object.values(e.response.data.errors).join(" ");
        }
        this.$emit("alert", { message: message, type: "danger" });
        // alert(JSON.parse(error.response.data.message)[0].additionalInfo);
      } finally {
        this.isLoading = false;
      }
    },
    async printOrders() {
      this.isLoading = true;
      const ids = this.serverParams.ids;
      // print items concurrently
      await Promise.all(ids.map(id => {
        return this.printOrder(id);
      }));

      return;
      // axios
      //   .post("printlabel/bulk", { orders: this.selected })
      //   .then(response => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", "file.pdf");
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(error => {
      //     vm.$emit("alert", {
      //       message: formatters.errors.fromResponse(error),
      //       type: "danger"
      //     });
      //   })
      //   .finally(() => {
      //     vm.isLoading = false;
      //   });
    },


    async deleteOrders() {
      const ids = this.serverParams.ids;
      try {
        const ids = this.serverParams.ids;
        const msg = `Are you sure you would like to delete the ${ids.length} entries chosen?`;

        if (!Cookies.get(hash(msg))) {
          let dialog = await this.$dialog.confirm(msg, {
            view: "pausable"
          });
          dialog.close();
        }
      } catch (e) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.delete("orders", { data: { orders: ids } });
        console.log('delete response', response);
        await this.clearSessionAndFetch(this.orderType.name);
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.serverParams.ids = [];
      }
    },

    async onImported() {
      console.log('onImpted success');
      await this.clearSessionAndFetch(this.orderType.name);
      this.$emit("alert", {
        message: "Orders imported!",
        type: "success"
      });
    },
    async showOrder(orderId) {
      try {
        this.isLoading = true;
        const keys = Object.keys(this.shownObjs);
        if (keys.indexOf(`${orderId}`) < 0) {
          // this.isLoading = true;
          const { data } = await axios.get("/orders/" + orderId);
          this.shownObjs = Object.assign({}, this.shownObjs, { [orderId]: data });
          this.shown = data;
          // this.isLoading = false;
        } else {
          this.shown = this.shownObjs[orderId];
        }
        // wait for the next event cycle before showing modal
        await this.$nextTick();
        this.isLoading = false;
        this.$refs.viewOrderModal.show();
      } catch (e) {
        console.log('view order modal error: ', e.message);
      }
    },
    async onShowOrderHide() {
      console.log('closing modal');
      this.shown = null;
    },
    getWeight(weight) {
      return {
        lb: Math.floor(weight / 16),
        oz: Math.round(weight % 16)
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Orders.vue